import styled from "styled-components";
import { Link } from "react-router-dom";

export const NavBar = styled.header``;

export const NavigationContainer = styled.div`
  height: 90px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #63c0ae;
  z-index: 999;
`;
export const LogoContainer = styled(Link)`
  height: 100%;
  width: 70px;
  padding: 10px;
  margin-left: 3%;
  margin-bottom: 10px;
`;

export const NavLinks = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 3px;
`;

export const NavLink = styled(Link)`
  padding: 10px 15px;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;

  @media only screen and (max-width: 760px) {
    font-size: 17px;
    padding: 7px;
  }
`;
